import { Link } from 'react-router-dom';

export function UnauthorizedPage() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        padding: '32px',
        textAlign: 'center',
      }}
    >
      <div style={{ fontSize: '56px', marginBottom: '16px' }}>🛡️</div>
      <h1 style={{ fontFamily: 'var(--display)', fontSize: '28px', fontWeight: 600, color: 'var(--navy)', margin: '0 0 10px' }}>
        403 — Access Restricted
      </h1>
      <p style={{ color: 'var(--muted)', fontSize: '14px', maxWidth: '480px', margin: '0 0 24px', lineHeight: 1.5 }}>
        You do not have the necessary organizational permissions or role privileges to view this administrative page.
      </p>
      <Link
        to="/dashboard"
        className="admin-btn admin-btn--primary"
      >
        Return to Learner Portal
      </Link>
    </div>
  );
}
